import React from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';
import FieldValidationResultMessage from './FieldValidationResultMessage.js';

const FieldWrapper = ({ type, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const has_error = (props.errors && isNotEmpty(props.errors, props.name)) ? props.errors[props.name] : false;

	const is_fake = props?.is_fake ?? false;
	const is_zoomable = props?.is_zoomable ?? false;
	const after_message = (isNotEmpty(props, 'after_message')) ? props.after_message : false;
	const after_component = props?.after_component ?? false;
	const max_length = props?.max_length ?? false;
	const min_length = props?.min_length ?? false;
	const has_validation = props?.validation ?? false;
	const error_msg_position_class = props?.error_msg_position_class ?? null;
	const display_error_at_bottom = props?.display_error_at_bottom ?? false;
	const hide_error_msg = props?.hide_error_msg ?? false;

	let classes = props?.classname ?? `input ${type}`;
	classes = parseClasses(classes, props._class, type);
	if(has_error) classes += ' has_error';
	if(['file'].includes(type)) classes += ' is_small_input';
	if(max_length || min_length) classes += ' with_char_length';

	const label_props = {
		tooltip:props.tooltip,
		...props.label_props,
		autotranslate:props.autotranslate,
		extra_contents:props.extra_contents,
		name:props.name,
	};

	const div_classes = ['react_field', `type_${type}`];
	if(isNotEmpty(props, '_field_class')) div_classes.push(props._field_class);
	if(is_fake) div_classes.push('is_fake_field');
	if(is_zoomable) div_classes.push('zoomable_field');

	const div_props = {
		onBlur:props.onBlur,
		onClick:props.onClick,
		onFocus:props.onFocus,
		onMouseEnter:props.onMouseEnter,
		onMouseLeave:props.onMouseLeave,
	};

	return (
		<div class={div_classes.join(" ")} style={props._field_style} {...div_props}>
			<div class={classes} style={props._style}>
				<FieldLabel {...label_props}>{props.label}</FieldLabel>

				<div class={`field_container this_${type}`}>
					{props.children}

					{(has_error && !display_error_at_bottom && !hide_error_msg) && (
						<FieldErrorMessage
							error_msg_position_class={error_msg_position_class}
						>{has_error}</FieldErrorMessage>
					)}

					{(isNotEmpty(props, 'after_message_tmp')) && (
						<div class="gui_after_message">{i18n(props.after_message_tmp)}</div>
					)}

					{(isNotEmpty(props, 'sided_legend')) && (
						<div class="sided_legend">{props.sided_legend}</div>
					)}
				</div>

				{(type == 'select' && is_fake && props.values.length > 0) && (
					<ul class="gui_fake_options">
						{props.values.map((opt, o) => {
							return (
								<li key={`fake_option_${o}`}>{opt}</li>
							)
						})}
					</ul>
				)}
			</div>

			{(has_error && display_error_at_bottom && !hide_error_msg) && (
				<FieldErrorMessage
					error_msg_position_class={error_msg_position_class}
				>{has_error}</FieldErrorMessage>
			)}

			{(after_message !== false) && (
				<div class="gui_after_message">
					{i18n(after_message)}
				</div>
			)}

			{(after_component !== false) && (
				<span class="label_additional_msg gui_after_message whole_contents">
					{after_component}
				</span>
			)}

			{(has_validation !== false) && (
				<FieldValidationResultMessage
					status={has_validation}
					error_msg_position_class={error_msg_position_class}
				/>
			)}
		</div>
	)
};

export default injectIntl(FieldWrapper);